var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Echart',{attrs:{"options":_vm.options,"id":"centreRight2Chart1","height":"200px","width":"260px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }